import { Notification, KIND as NotificationKIND } from "baseui/notification";

export function PageNotFound() {
  return (
    <Notification kind={NotificationKIND.negative}>There requested url was not found (Status Code 404)</Notification>
  );
}
